import { useCallback } from 'react';
import { HomeInsuranceRiskPackage } from '@app/domain/model/eshop/home/HomeInsuranceRiskPackage';
import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';
import { trackAddToCart } from '@app/infrastructure/gtm/home/trackAddToCart';
import { HOME_INSURANCE_STEPS } from '@app/app/esales/home/_sections/steps/HOME_INSURANCE_STEPS';

interface UseHomeGtmTrackingParams {
    selectedRisk: Nullable<HomeInsuranceRiskPackage>;
    selectedRiders: ProductDataRider[];
}

interface TrackStepCompletionParams {
    currentStepKey: string;
}

export function useHomeGtmTracking({ selectedRisk, selectedRiders }: UseHomeGtmTrackingParams) {
    const trackStepCompletion = useCallback(
        ({ currentStepKey }: TrackStepCompletionParams) => {
            if (currentStepKey !== HOME_INSURANCE_STEPS.ADDITIONAL_RISKS) {
                return;
            }

            trackAddToCart(selectedRisk, selectedRiders);
        },
        [selectedRisk, selectedRiders],
    );

    return {
        trackStepCompletion,
    };
}
